import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useBoardItemComment } from "../../hooks/useBoardItemComment";
import { SiteContext } from "../../context/SiteProvider";
import { PopupContext } from "../../context/PopupProvider";
import MyButton from "../../components/MyButton";

const DeleteBoardItemCommentDialog = ({
  mode = "comment",
  boardCode,
  itemNo,
  commentNo,
  deleteMessage = "댓글이 삭제되었습니다.",
  onRedirect = () => {},
}) => {
  const { t } = useTranslation();
  const { deleteBoardItemCommentMutation } = useBoardItemComment();
  const queryClient = useQueryClient();
  const { setLoadingScreen } = useContext(SiteContext);

  const { closePopup } = useContext(PopupContext);

  const onDelete = async () => {
    setLoadingScreen(true);

    deleteBoardItemCommentMutation.mutate(
      { boardCode, itemNo, commentNo },
      {
        onSuccess: () => {
          alert(deleteMessage);
          queryClient.invalidateQueries({
            queryKey: [
              "/board-item-comment?boardCode={boardCode}&itemNo={itemNo}&page=1",
            ],
          });
          closePopup();
          onRedirect();
        },
        onError: () => {
          alert("삭제 취소됨");
        },
        onSettled: () => {
          setLoadingScreen(false);
        },
      }
    );
  };

  return (
    <div className="md:p-12 p-8 rounded-2xl bg-white">
      <p className="md:text-2xl text-xl font-medium text-center mb-1">
        {mode === "comment" ? "댓글" : "답변"}을 삭제하시겠습니까?
      </p>
      <p className="md:text-xl text-gray-dark text-center mb-6">
        삭제하면 복구할 수 없습니다.
      </p>
      <div className="flex justify-center items-center gap-4">
        <MyButton onClick={closePopup}>{t("common.buttons.cancel")}</MyButton>
        <MyButton variant="contained" color="#e74c3c" onClick={onDelete}>
          {t("common.buttons.delete")}
        </MyButton>
      </div>
    </div>
  );
};

export default DeleteBoardItemCommentDialog;
